import { client } from "../request";

export interface IStatusAccouting {
  id: number | string;
  projectId: number;
  status: string;
  contractDate?: string;
  model: "Estimate" | "Invoice" | "Purchase";
}

export async function changeStatusAccouting(option: IStatusAccouting): Promise<number> {
  const res = await client.post("update_status.php", option);

  return res.id;
}
